import { Typography, styled } from "@mui/material";

const DefaultStyle = styled(Typography)`
  font-size: 0.75rem;
  opacity: 0.5;
`;

interface Props {
  isValid: boolean;
  children: string;
}

export default function PasswordRequirement({ isValid, children }: Props) {
  return (
    <DefaultStyle
      sx={{
        opacity: isValid ? 1 : 0.5,
        fontWeight: isValid ? "bold" : "normal",
        color: isValid ? "success.main" : "error.main",
      }}
    >
      <li>{children}</li>
    </DefaultStyle>
  );
}
